import React from "react";
import PurchaseOrderList from "../../components/screen/purchaseOrder/PurchaseOrderList";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { ThemeProvider } from "@emotion/react";
import { theme } from "../../components/constants/muiTheme";
import BreadcrumbPurchaseOrder from "../../components/screen/purchaseOrder/BreadcrumbPurchaseOrder";

const PurchaseOrder = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={
          (isWarehouse ? "Central Warehouse " : "") + "Purchase Order Manual"
        }
        breadcrumb={
          <BreadcrumbPurchaseOrder
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
        mainComponent={
          <ThemeProvider theme={theme}>
            <PurchaseOrderList
              isWarehouse={isWarehouse ? isWarehouse : false}
            />
          </ThemeProvider>
        }
        pageRole={isWarehouse ? 29 : 9}
      />
    </div>
  );
};

export default HOC(PurchaseOrder);
